export enum TabId {
  COMPLETED = 'completed',
  DECLINED = 'declined',
  REFERRALS = 'referrals',
  UPCOMING = 'upcoming',
}
